import { render, staticRenderFns } from "./SushiDiaoxian.vue?vue&type=template&id=1c59f09d&scoped=true&"
import script from "./SushiDiaoxian.vue?vue&type=script&lang=js&"
export * from "./SushiDiaoxian.vue?vue&type=script&lang=js&"
import style0 from "./SushiDiaoxian.vue?vue&type=style&index=0&id=1c59f09d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c59f09d",
  null
  
)

export default component.exports